import { REDIS_MOBILE_PREFIX } from '~/configs/project.config';
import { getRuntimeContext } from '../helpers/server';
import type { H3Event } from 'h3';
import { PlatformEnum } from '~/src/store/modules/environment/types';

export const isMobile = (userAgent: string) => {
  // 只要是在小程序环境或者app环境 都是移动端
  if (isMiniProgram(userAgent) || isApp(userAgent)) {
    return true;
  }

  return /Mobile|iP(hone|ad)|Android|BlackBerry|IEMobile/.test(userAgent);
};

export const isMiniProgram = (userAgent: string) => {
  return /miniprogram/.test(userAgent.toLowerCase());
};

export const isApp = (userAgent: string) => {
  return /51cto_app/.test(userAgent.toLowerCase());
};

export const getPlatform = (userAgent: string) => {
  if (isMiniProgram(userAgent)) {
    return PlatformEnum.MINI_PROGRAM;
  }

  if (isApp(userAgent)) {
    return PlatformEnum.APP;
  }

  return isMobile(userAgent) ? PlatformEnum.H5 : PlatformEnum.PC; // 测试--h5改成app
};

// default is pc, m = mobile
export const getDeviceRedisKeyPrefix = (event: H3Event): string => {
  const runtimeExtraContext = getRuntimeContext(event);
  const DeviceKey = runtimeExtraContext.isMobile ? REDIS_MOBILE_PREFIX : '';

  return DeviceKey;
};

export const getPathRedisKey = (pathname: string) => {
  return pathname.replaceAll('/', 'I').replaceAll('.', 'D');
};
